import { mapViewActions } from './mapViewActionCreator';
import { statusKeyNameMap } from '../mapViewHelper';

const initialState = {
  isLoading: false,
  isLoaded: false,
  map: null,
  cnData: [],
  error: null,
  filters: {
    statuses: [],
    client: null,
    locations: []
  },
  cnFilterLocationList: [],
  cnFilterStatusList: [],
  filteredData: [],
  listings: []
};

const enrichCnData = cnData => {
  return cnData.map(cn => {
    let assigned = false;
    statusKeyNameMap.forEach((v, k) => {
      if (v.statusList.indexOf(cn.status) !== -1) {
        cn[k] = 1;
        assigned = true;
      }
    });
    if (!assigned) {
      cn.UNEXPECTED = 1;
    }
    return cn;
  });
};

const getListForFilter = (payload, map) => {
  const valList = [];
  payload.map(map).forEach(val => {
    if (valList.indexOf(val) === -1) {
      valList.push(val);
    }
  });
  valList.sort();
  return valList.map(val => {
    return { key: val, val };
  });
};

const getFilteredData = (rawData, filters) => {
  if (!rawData) {
    return [];
  }
  return rawData.filter(row => {
    const statusCheck =
      !filters.statuses ||
      filters.statuses.length === 0 ||
      filters.statuses.indexOf(row.status) !== -1;
    const clientCheck =
      !filters.client ||
      !filters.client.id ||
      filters.client.id === row.clientId;
    const locationCheck =
      !filters.locations ||
      filters.locations.length === 0 ||
      filters.locations.indexOf(row.locationCode) !== -1;
    return statusCheck && clientCheck && locationCheck;
  });
};

const mapViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case mapViewActions.GET_CN_DATA: {
      const tempState = Object.assign({}, state, action.payload);
      const newState = Object.assign({}, tempState, {
        cnData: enrichCnData(tempState.cnData)
      });
      return Object.assign({}, newState, {
        cnFilterLocationList: getListForFilter(
          newState.cnData,
          cn => cn.locationCode
        ),
        cnFilterStatusList: getListForFilter(newState.cnData, cn => cn.status),
        filteredData: getFilteredData(newState.cnData, newState.filters)
      });
    }
    case mapViewActions.UPDATE_FILTER: {
      const newState = Object.assign({}, state, {
        filters: Object.assign({}, state.filters, {
          [action.key]: action.payload
        })
      });
      return Object.assign({}, newState, {
        filteredData: getFilteredData(newState.cnData, newState.filters)
      });
    }
    case mapViewActions.SET_MAP_OBJECT: {
      return Object.assign({}, state, { map: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default mapViewReducer;
